<template>
  <div>
    <b-row align-h="center" class="mt-5">
      <b-col
        class="p-5 mb-4 mb-lg-0 mr-lg-4 keep-account"
        lg="5"
        md="11"
        sm="11"
        cols="11"
      >
        <div class="keep-account-labels">
          <p>{{ $t("keepAccount") }}</p>
          <h2>{{ $t("stayInTrebel") }}</h2>
          <hr />
          <template v-for="(item, index) in keepAccountInfo" class="pt-5">
            <delete-account-step-one-content-list
              :key="index"
              :imgSrc="item.imgSrc"
            >
              {{ item.text }}
            </delete-account-step-one-content-list>
          </template>
        </div>
        <b-row align-h="center">
          <b-col lg="10">
            <div class="keep-account-btn" v-b-modal.modal-keep-account>
              <modal
                :action="account"
                modalId="modal-keep-account"
                :title="$t('keepAccountModalTitle')"
                :subTitle="$t('keepAccountModalSubTitle')"
              ></modal>
              {{ $t("keepAccount") }}
            </div>
          </b-col>
        </b-row>
      </b-col>
      <b-col class="p-5 close-account" lg="5" md="11" sm="11" cols="11">
        <div class="close-account-labels">
          <p>{{ $t("closeAccount") }}</p>
          <h2>{{ $t("missYou") }}</h2>
          <hr />
          <template v-for="(item, index) in closeAccountInfo" class="pt-5">
            <delete-account-step-one-content-list
              :key="index"
              :imgSrc="item.imgSrc"
            >
              {{ item.text }}
            </delete-account-step-one-content-list>
          </template>
        </div>
        <b-row align-h="center">
          <b-col lg="10">
            <div
              ref="btnShow"
              class="close-account-btn"
              @click="checkAccount()"
            >
              <modal
                :action="account"
                modalId="modal-delete-account"
                :title="$t('deleteAccountModalTitle')"
                :subTitle="$t('deleteAccountModalSubTitle')"
              ></modal>
              {{ $t("deleteAccount") }}
            </div>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import DeleteAccountStepOneContentList from "./DeleteAccountStepOneContentList.vue";
import { pageNavigation } from "../../../mixins/navigation";
import i18n from "../../../i18n";
import Modal from "../../Modal.vue";

export default {
  name: "DeleteAccountStepOne",
  components: {
    DeleteAccountStepOneContentList,
    Modal
  },
  mixins: [pageNavigation],
  mounted() {
    const token = localStorage.getItem("token") || null ;
    if (!this.$route.query.da && !token) {
      window.location = "https://home.trebel.io";
    }
  },
  methods: {
    checkAccount() {
      const token = localStorage.getItem("token") || null;
      if (!token) {
        this.$root.$emit("bv::show::modal", "modal-delete-account", "#btnShow");
      } else {
        this.$router.push({ query: { q: "check" } }).catch(() => {});
      }
    }
  },
  data() {
    return {
      closeAccountInfo: [
        {
          text: i18n.t("youWillNoLonger"),
          imgSrc: "assets/images/x.svg"
        },
        {
          text: i18n.t("youWillLoseYourDownloads"),
          imgSrc: "assets/images/x.svg"
        }
      ],
      keepAccountInfo: [
        {
          text: i18n.t("keepYouSongs"),
          imgSrc: "assets/images/note.svg"
        },
        {
          text: i18n.t("keepYourCoins"),
          imgSrc: "assets/images/note.svg"
        },
        {
          text: i18n.t("enjoyFreeMusic"),
          imgSrc: "assets/images/note.svg"
        }
      ]
    };
  }
};
</script>

<style scoped></style>
